import { overlay } from 'overlay-kit';
import { type QuizCopiedChoice, QuizCopiedDialog } from './components/QuizCopiedDialog';

/**
 * 복사 결과 모달을 열고 사용자가 고른 다음 행동을 돌려준다.
 *
 * `overlay.openAsync<T>` 를 쓰는 이유는 결과가 boolean 이 아니기 때문이다 — `confirmDialog` 는
 * 확인/취소 두 값만 표현한다(`ui_v3/components/dialog/utils.ts` 가 `Promise<boolean>` 으로 고정).
 * 선례: `module/plan/dialog/InviteCompleteDialog.tsx` 도 같은 이유로 `openAsync<'confirm' | …>`.
 */
export const showQuizCopiedDialog = () => overlay.openAsync<QuizCopiedChoice>(({
  unmount
}) => <QuizCopiedDialog onClose={unmount} />);